import DefaultTemplate from '@templates/DefaultTemplate';
import { Wrapper } from './LeaderPage.styled';
import { useEffect, useRef, useState } from 'react';
import db from '@utils/db';
import { useStore } from '@store/appStore';
import { useAuthentication } from '@providers/AuthProvider';
import { useRouter } from 'next/router';
import moment from 'moment';
import SchoolLeader from '@components/SchoolLeader';
import {useWindowSize} from 'react-use';
import { breakpoints } from '@styles/tokens';
import ErrorPage from '../ErrorPage';

export const LeaderPage = () => {
  const { client, whoIsLoggedIn, filterDate, settings } = useStore();
  const { width } = useWindowSize();
  
  return (
    <DefaultTemplate>
      <Wrapper>
        {width < breakpoints.mobile?<ErrorPage errorCode={411} />:<SchoolLeader />}
      </Wrapper>
    </DefaultTemplate>
  );
};

export default LeaderPage;
